import { Link } from "react-router";
import styles from './Footer.module.scss';
export const Footer = ({links}) => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <p className={styles.rights}>{year} © All rights Reserved.</p>
      {links &&
      <div className={styles.links}>
        {links.map((item,index)=>{
          if (item.type === 'other') {
            return (<a href={item.link} className={styles.link} key={index}>{item.text}</a>)
          }else {
            return(<Link to={item.link} key={index} className={styles.link}>{item.text}</Link>)
          }
        })}
      </div>
      }
    </footer>
  );
};